import { useRef, useEffect } from 'react';
import { podObserver } from 'utils/custom-intersection-observer';

export function usePodObserver(onVisible) {
  const observeElemRef = useRef(null);

  useEffect(() => {
    const el = observeElemRef.current;

    podObserver.observe(el, onVisible);

    return () => {
      podObserver.unobserve(el);
    };
  }, [onVisible]);

  return observeElemRef;
}
